import React from 'react'
import Loading from '../../atoms/Loading'

export default () => (
    <div style={{ minHeight: '200px', padding: '30px 0' }}>
        <Loading />
    </div>
)


// WEBPACK FOOTER //
// ./src/v2SPRINTA/molecules/LoadingPage/index.js